import React, { useCallback, useContext } from 'react';
import ProgressBackdrop from '../../preorder/components/ProgressBackdrop';
import Providers from '../components/Providers';
import displayDataContext from '../contexts/displayData';
import favoriteItemsContext from '../contexts/favoriteItems';
import providersContext from '../contexts/providers';

export default () => {
  const { isLoading } = useContext(providersContext);
  const {
    isLoading: favoriteItemsIsLoading,
    toggleItems,
  } = useContext(favoriteItemsContext);
  const { displayData } = useContext(displayDataContext);

  const onFavoritButtonClick = useCallback(async (id) => {
    await toggleItems([{ itemId: id, itemType: 'PROVIDER', type: 'LIKE' }]);
  }, [toggleItems]);

  if (isLoading || favoriteItemsIsLoading) return <ProgressBackdrop isShow />;

  return (
    <Providers
      data={displayData}
      onFavoritButtonClick={onFavoritButtonClick}
    />
  );
};
